/* shared attributes for all Pinterest tracking pixelsl */

export const sharedPinterestAttributes = {
  tid: '2617388737069',
  noscript: '1',
};
